import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

export default class extends Controller {
  connect() {
    console.log("remote modal connected")

    this.modal = new Modal(this.element, { backdrop: "static" })
    this.modal.show()

    // Back button handler
    this.popstateHandler = this.closeModalOnBack.bind(this)
    window.addEventListener("popstate", this.popstateHandler)

    // Push state only once
    if (!history.state || !history.state.modalOpen) {
      history.pushState({ modalOpen: true }, "")
    }

    // Handle BFCache restore
    window.addEventListener("pageshow", (event) => {
      if (event.persisted) this.hideModal()
    })
  }

  disconnect() {
    window.removeEventListener("popstate", this.popstateHandler)
    this.element.remove()
  }

  // triggered when real back button is pressed
  closeModalOnBack(event) {
    if (this.isOpen()) {
      event.preventDefault()
      this.hideModal()
      return
    }
    // Let browser navigate naturally
  }

  hideModal() {
    if (this.isOpen()) {
      this.modal.hide()
    }
  }

  hideBeforeRender(event) {
    console.log("Hide modal before turbo render")

    if (window.location.pathname.includes("/v2/schedules") || window.location.pathname.includes("/v2/playlists")) {
      window.location.reload()
    }

    if (this.isOpen()) {
      event.preventDefault()
      this.element.addEventListener("hidden.bs.modal", event.detail.resume)
      this.modal.hide()
    }
  }

    beforeCache() {
        if (this.isOpen()) {
            this.modal.hide()
        }
        const frame = this.element.closest("turbo-frame")
        if (frame) frame.innerHTML = ""
    }

    isOpen() {
        return this.element.classList.contains("show")
    }
}